import type { Locale } from 'ant-design-vue/es/locale';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';

export const antdLocales: Record<App.I18n.LangType, Locale> = {
  'zh-CN': zhCN,
  'en-US': enUS
};
